import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID, importProvidersFrom } from '@angular/core'
import { provideRouter } from '@angular/router'

import { registerLocaleData } from '@angular/common'
import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http'
import localeEs from '@angular/common/locales/es'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AuthModule } from '@auth0/auth0-angular'
import { errorInterceptor, loaderInterceptor, tokenInterceptor } from '@interceptors'
import { provideIonicAngular } from '@ionic/angular/standalone'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { provideNgxStripe } from 'ngx-stripe'
import { routes } from './app.routes'
import { appEnv } from './env'

registerLocaleData(localeEs)

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', `.json?v=${Date.now()}`)
}

export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: LOCALE_ID, useValue: 'es-ES' },
		{ provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
		provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor, loaderInterceptor])),
		provideIonicAngular({ animated: false }),
		provideNgxStripe(appEnv.stripePublicKey),
		provideRouter(routes),
		importProvidersFrom([
			AuthModule.forRoot({
				domain: appEnv.auth0Domain,
				clientId: appEnv.auth0ClientId,
				authorizationParams: {
					audience: '/api/login',
					redirect_uri: window.location.origin + '/login'
				}
			}),
			BrowserAnimationsModule,
			HttpClientModule,
			TranslateModule.forRoot({
				defaultLanguage: 'es',
				loader: {
					provide: TranslateLoader,
					useFactory: HttpLoaderFactory,
					deps: [HttpClient]
				}
			})
		])
	]
}
